import React from 'react';

export default function UpgradePrice({ pricing, plan, cycle, PriceComponent }) {
  const price = pricing.price(plan, cycle);
  if (pricing.loading) return <PriceComponent aria-live="polite">Loading price…</PriceComponent>;
  if (!price) return <div role="alert">Price unavailable. <button type="button" onClick={pricing.retry}>Try again</button></div>;
  return <><PriceComponent>{price.headline}</PriceComponent><p style={{ margin: '0 0 12px', textAlign: 'center', fontSize: 14 }}>{price.billing}</p></>;
}
